export type { TermsDocument } from './types/terms-document';
export { TermsDocumentType } from './types/terms-document';
export { useTerms } from './client/terms.hook';
export { RequireConsentForDocuments } from './client/require-consent-for-documents';
export { TermsProvider } from './client/terms.provider';
import getTermsConfiguration from './configuration';
export { getTermsConfiguration };
